/* ==========================================
   CHEECH & CHONG — THE JUDGE'S STASH — NATIONAL STORE LOCATOR LANDER
   Shopify Liquid Template — Asset JS
   ========================================== */

(function() {
  'use strict';

  /* ─── Scope fix ───
     On Shopify, the .ht-page wrapper only contains the hero section.
     All other sections (reviews, product, lifestyle, etc.) are siblings
     outside it, so .ht-page-prefixed CSS selectors fail. We promote
     .ht-page to the nearest common ancestor of all our sections. */
  (function fixScope() {
    var hero = document.querySelector('.ht-hero-section');
    if (hero && !hero.classList.contains('ht-page')) {
      hero.classList.add('ht-page');
    }
    // Fallback: also try the parent of all shopify sections
    var mainContent = document.getElementById('MainContent');
    if (mainContent && !mainContent.classList.contains('ht-page')) {
      mainContent.classList.add('ht-page');
    }
  })();

  /* ─── Sticky gallery fix ───
     Shopify theme sets overflow: hidden/auto on ancestor .shopify-section
     and #MainContent wrappers, which breaks position: sticky on the
     product gallery. Override to overflow: visible on those ancestors. */
  (function fixStickyGallery() {
    var gallery = document.querySelector('.ht-product__gallery');
    if (!gallery) return;
    var el = gallery.parentElement;
    while (el && el !== document.documentElement) {
      var ov = getComputedStyle(el).overflow;
      if (ov !== 'visible' && ov !== '') {
        el.style.overflow = 'visible';
      }
      el = el.parentElement;
    }
  })();

  // Info tabs toggle
  document.querySelectorAll('.ht-info-tab').forEach(function(tab) {
    tab.addEventListener('click', function() {
      var target = tab.getAttribute('data-tab');
      document.querySelectorAll('.ht-info-tab').forEach(function(t) { t.classList.remove('active'); });
      document.querySelectorAll('.ht-tab-content').forEach(function(tc) { tc.classList.remove('active'); });
      tab.classList.add('active');
      var panel = document.getElementById(target);
      if (panel) panel.classList.add('active');
    });
  });

  /* ─── Format selector ───
     The Judge's Stash sells two formats at different prices ("The Spirit"
     $59.99, "Spirit + Kit" $89.99), so picking a format has to rewrite the
     pricing tiers — unlike the seltzer landers where every flavour cost the
     same. Each option carries data-price; selecting one rewrites every tier's
     data-base-price and re-runs updatePricing() so the subscribe discount is
     recalculated off the new base. */
  function applyFormatPrice(option) {
    if (!option) return;
    var price = parseFloat(option.getAttribute('data-price'));
    if (isNaN(price)) return;
    document.querySelectorAll('.ht-pricing-tier').forEach(function(tier) {
      tier.setAttribute('data-base-price', price.toFixed(2));
    });
    updatePricing();
  }

  document.querySelectorAll('.ht-flavor-option').forEach(function(option) {
    option.addEventListener('click', function() {
      document.querySelectorAll('.ht-flavor-option').forEach(function(o) { o.classList.remove('active'); });
      option.classList.add('active');
      applyFormatPrice(option);
    });
  });

  // ─── Pricing toggle (Subscribe & Save vs Buy Once) ───
  var purchaseMode = 'subscribe';
  // The selling plan ID is a theme setting, read off the Add to Cart button at
  // click time — see the cart handler below. Nothing to hardcode here.
  var subscribeDiscount = 0.25; // 25% off

  // Dynamically update tier prices based on purchase mode
  function updatePricing() {
    var tiers = document.querySelectorAll('.ht-pricing-tier');
    var benefits = document.getElementById('htSubscribeBenefits');

    tiers.forEach(function(tier) {
      var basePrice = parseFloat(tier.getAttribute('data-base-price'));
      if (isNaN(basePrice)) return;
      var displayEl = tier.querySelector('.ht-tier-display-price');
      var originalEl = tier.querySelector('.ht-tier-original-price');
      if (!displayEl) return;

      if (purchaseMode === 'subscribe') {
        var discounted = (basePrice * (1 - subscribeDiscount)).toFixed(2);
        displayEl.textContent = '$' + discounted;
        if (originalEl) {
          originalEl.textContent = '$' + basePrice.toFixed(2);
          originalEl.style.display = 'inline';
        }
      } else {
        displayEl.textContent = '$' + basePrice.toFixed(2);
        if (originalEl) {
          originalEl.textContent = '';
          originalEl.style.display = 'none';
        }
      }
    });

    // Show/hide subscribe benefits
    if (benefits) {
      benefits.style.display = (purchaseMode === 'subscribe') ? 'block' : 'none';
    }
  }

  document.querySelectorAll('.ht-pricing-toggle__option').forEach(function(option, idx) {
    option.addEventListener('click', function() {
      document.querySelectorAll('.ht-pricing-toggle__option').forEach(function(o) { o.classList.remove('active'); });
      option.classList.add('active');
      purchaseMode = (idx === 0) ? 'subscribe' : 'onetime';
      updatePricing();
    });
  });

  // Set initial pricing on page load (Subscribe & Save is default active).
  // Sync off the pre-selected format so the tiers can never disagree with it.
  updatePricing();
  applyFormatPrice(document.querySelector('.ht-flavor-option.active'));

  // ─── Pricing tier selection (1 / 2 / 3 bottles) ───
  var selectedQuantity = 1;
  var tiers = document.querySelectorAll('.ht-pricing-tier');
  // Default: select the first tier
  if (tiers.length) tiers[0].classList.add('selected');

  tiers.forEach(function(tier, idx) {
    tier.addEventListener('click', function() {
      tiers.forEach(function(t) { t.classList.remove('selected'); });
      tier.classList.add('selected');
      
      // Judge's Stash sells in 1 / 2 / 3 bottle tiers (the live page's ladder)
      var qtyMap = [1, 2, 3];
      selectedQuantity = qtyMap[idx] || 1;
    });
  });

  // Thumbnail gallery click
  document.querySelectorAll('.ht-product__thumbnails img').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      document.querySelectorAll('.ht-product__thumbnails img').forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      var mainImg = document.getElementById('htMainProductImage');
      if (mainImg) {
        mainImg.src = thumb.src.replace('width=200', 'width=1200');
      }
    });
  });

  /* ----- Carousel indicator sync -----
     Wires a scroll-snap track to a row of position indicators (bars). The
     active bar follows whichever card is centered, and clicking a bar
     scrolls that card into view. */
  function bindCarousel(track, dots) {
    if (!track || !dots || !dots.length) return;
    var cards = track.children;
    if (!cards.length) return;

    function setActive(idx) {
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('active', i === idx);
      }
    }

    function activeIndex() {
      var trackRect = track.getBoundingClientRect();
      var center = trackRect.left + trackRect.width / 2;
      var bestIdx = 0;
      var bestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var r = cards[i].getBoundingClientRect();
        var c = r.left + r.width / 2;
        var d = Math.abs(c - center);
        if (d < bestDist) { bestDist = d; bestIdx = i; }
      }
      return bestIdx;
    }

    var scheduled = false;
    track.addEventListener('scroll', function() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function() {
        setActive(activeIndex());
        scheduled = false;
      });
    }, { passive: true });

    for (var i = 0; i < dots.length; i++) {
      (function(idx) {
        dots[idx].addEventListener('click', function() {
          var card = cards[idx];
          if (!card) return;
          var offset = card.offsetLeft - (track.clientWidth - card.clientWidth) / 2;
          track.scrollTo({ left: Math.max(0, offset), behavior: 'smooth' });
          setActive(idx);
        });
      })(i);
    }

    setActive(0);
  }

  // Reviews carousel
  var reviewTrack = document.querySelector('.ht-reviews__track');
  bindCarousel(
    reviewTrack,
    document.querySelectorAll('.ht-reviews .carousel-dot')
  );

  // Reviews arrow navigation
  var reviewPrev = document.getElementById('htReviewPrev');
  var reviewNext = document.getElementById('htReviewNext');
  if (reviewTrack && reviewPrev && reviewNext) {
    var reviewStep = function() {
      var first = reviewTrack.children[0];
      return first ? first.getBoundingClientRect().width + 24 : 360;
    };
    reviewPrev.addEventListener('click', function() {
      reviewTrack.scrollBy({ left: -reviewStep(), behavior: 'smooth' });
    });
    reviewNext.addEventListener('click', function() {
      reviewTrack.scrollBy({ left: reviewStep(), behavior: 'smooth' });
    });
  }

  // Features carousel
  var featureTrack = document.querySelector('.ht-features__track');
  var featureDots = document.querySelectorAll('.ht-features__nav-dot');
  bindCarousel(featureTrack, featureDots);

  // Features arrow steps to the next card
  var featureArrow = document.querySelector('.ht-features__nav-arrow');
  if (featureArrow && featureTrack) {
    featureArrow.addEventListener('click', function() {
      var first = featureTrack.children[0];
      var step = first ? first.getBoundingClientRect().width + 20 : 300;
      featureTrack.scrollBy({ left: step, behavior: 'smooth' });
    });
  }

  // FAQ accordion toggle
  document.querySelectorAll('.ht-faq-question').forEach(function(question) {
    question.addEventListener('click', function() {
      var item = question.parentElement;
      var isActive = item.classList.contains('active');
      document.querySelectorAll('.ht-faq-item').forEach(function(i) { i.classList.remove('active'); });
      if (!isActive) {
        item.classList.add('active');
      }
    });
  });

  /* ─── Add to Cart via server-rendered form (SlideCart HQ intercepts) ───
     Variant IDs are NOT hardcoded here. Each Format Option block carries its
     own Shopify variant ID as a theme setting, rendered onto the option as
     data-variant-id, so the whole thing is editable in the customizer with no
     code changes. The selling plan ID arrives the same way, on the button. */
  var addToCartBtn = document.getElementById('htAddToCartBtn');
  var cartForm = document.getElementById('htCartForm');
  var cartError = document.getElementById('htCartError');

  // A real Shopify variant ID is a long run of digits. Anything else - blank,
  // the old 00000000000001 placeholder, a pasted gid:// string - is a
  // misconfiguration, and posting it makes Shopify return 422. SlideCart has
  // no error path for that, so its drawer just spins forever. Catch it here.
  function isUsableVariantId(v) {
    if (!v) return false;
    v = String(v).trim();
    if (!/^\d+$/.test(v)) return false;
    if (/^0+$/.test(v.replace(/1$/, ''))) return false; // 00000000000001 etc.
    return v.length >= 10;
  }

  /* Variant resolution, in priority order:
       1. the Format Option block's own "Shopify Variant ID" setting
       2. the section's Variant Map, matched on the format name
     The map means the page works straight off an uploaded section file with no
     per-block clicking in the customizer, while the per-block field stays
     available as an override. */
  function parseVariantMap() {
    var host = document.querySelector('.ht-flavor-selector__options');
    var raw = host ? (host.getAttribute('data-variant-map') || '') : '';
    var map = {};
    raw.split(/[\r\n]+/).forEach(function(line) {
      var i = line.indexOf('=');
      if (i === -1) return;
      var k = line.slice(0, i).trim();
      var v = line.slice(i + 1).trim();
      if (k && v) map[k] = v;
    });
    return map;
  }
  var variantMap = parseVariantMap();

  function formatNameOf(option) {
    var n = option && option.querySelector('.ht-flavor-option__name');
    return n ? n.textContent.trim() : '';
  }

  function variantIdFor(option) {
    if (!option) return '';
    var own = (option.getAttribute('data-variant-id') || '').trim();
    if (own) return own;
    return variantMap[formatNameOf(option)] || '';
  }

  function showCartError(msg) {
    if (!cartError) { console.error('[judges-stash] ' + msg); return; }
    cartError.textContent = msg;
    cartError.hidden = false;
  }

  function clearCartError() {
    if (cartError) { cartError.hidden = true; cartError.textContent = ''; }
  }

  if (addToCartBtn && cartForm) {
    addToCartBtn.addEventListener('click', function() {
      clearCartError();

      var activeOption = document.querySelector('.ht-flavor-option.active')
                      || document.querySelector('.ht-flavor-option');
      var variantId = variantIdFor(activeOption);
      var formatName = formatNameOf(activeOption) || 'this format';

      if (!isUsableVariantId(variantId)) {
        showCartError(
          'This page is not finished being set up: "' + formatName + '" has no valid ' +
          'Shopify variant ID. Add a line "' + formatName + '=<variant id>" under ' +
          'Customize → JS Product Buy Box → Variant Map.'
        );
        return; // do NOT submit - a bad ID hangs the SlideCart drawer
      }

      cartForm.querySelector('[name="id"]').value = variantId;
      cartForm.querySelector('[name="quantity"]').value = selectedQuantity;

      // Selling plan comes from the section setting, read off the button
      var sellingPlanId = (addToCartBtn.getAttribute('data-selling-plan') || '').trim();
      var spInput = cartForm.querySelector('[name="selling_plan"]');
      if (purchaseMode === 'subscribe' && /^\d+$/.test(sellingPlanId)) {
        if (!spInput) {
          spInput = document.createElement('input');
          spInput.type = 'hidden';
          spInput.name = 'selling_plan';
          cartForm.appendChild(spInput);
        }
        spInput.value = sellingPlanId;
      } else if (spInput) {
        spInput.remove();
      }

      var originalHTML = addToCartBtn.innerHTML;
      addToCartBtn.textContent = 'ADDING...';
      addToCartBtn.disabled = true;

      // Submit the form — SlideCart HQ intercepts this, handles the
      // AJAX add, and opens the cart drawer with updated contents
      cartForm.querySelector('[type="submit"]').click();

      setTimeout(function() {
        addToCartBtn.innerHTML = originalHTML;
        addToCartBtn.disabled = false;
      }, 2000);
    });

    // Surface misconfiguration at page load rather than on first click
    (function auditVariantIds() {
      var missing = [];
      document.querySelectorAll('.ht-flavor-option').forEach(function(o) {
        if (!isUsableVariantId(variantIdFor(o))) {
          missing.push(formatNameOf(o) || 'unnamed format');
        }
      });
      if (missing.length) {
        console.warn('[judges-stash] Add to Cart is blocked — no valid Shopify variant ID for: '
          + missing.join(', ')
          + '. Add them under Customize → JS Product Buy Box → Variant Map.');
      } else {
        // Keep the server-rendered form in sync with the initially selected format.
        var initial = variantIdFor(document.querySelector('.ht-flavor-option.active')
                                || document.querySelector('.ht-flavor-option'));
        if (initial) cartForm.querySelector('[name="id"]').value = initial;
      }
    })();
  }

  // Smooth scroll for anchor links within this page
  document.querySelectorAll('.ht-page a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });

})();
